import { useState } from "react";
import SectionHeader from "@/components/feature/panel/SectionHeader";
import PanelLinks from "@/components/feature/panel/PanelLinks";
import { getDataClient } from "@/lib/dataClient";
import { examTypes, gradeOptions, subjectOptions } from "@/data/panels";

const inputClass =
  "w-full px-3 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:border-primary-400 focus:outline-none transition-colors";
const labelClass = "block text-sm font-medium text-foreground-700 mb-1.5";

export default function TestOlustur() {
  const [title, setTitle] = useState("");
  const [examType, setExamType] = useState("");
  const [grade, setGrade] = useState("");
  const [subject, setSubject] = useState("");
  const [duration, setDuration] = useState("");
  const [questionCount, setQuestionCount] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState<{ type: "success" | "error"; text: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage(null);

    if (!title.trim()) {
      setMessage({ type: "error", text: "Lütfen test adını yazın." });
      return;
    }

    setSaving(true);
    try {
      const dataClient = getDataClient();
      const { error } = await dataClient.from("exams").insert({
        title: title.trim(),
        exam_type: examType || null,
        lesson_name: subject || null,
        duration_minutes: duration ? Number(duration) : null,
        question_count: questionCount ? Number(questionCount) : 0,
        mode: "test",
        created_at: new Date().toISOString(),
      });
      if (error) throw error;

      setMessage({ type: "success", text: "Test başarıyla oluşturuldu." });
      setTitle("");
      setDuration("");
      setQuestionCount("");
    } catch (err) {
      setMessage({
        type: "error",
        text: err instanceof Error ? err.message : "Test oluşturulurken bir hata oluştu.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <SectionHeader
        title="Test Oluştur"
        description="Yeni bir test oluştur ve öğrencilerine sun."
      />

      <form onSubmit={handleSubmit} className="rounded-lg border border-background-200 bg-background-50 p-6">
        <div>
          <label className={labelClass}>Test Adı</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={inputClass}
            placeholder="Örn: Türev Tarama Testi"
          />
        </div>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelClass}>Sınav</label>
            <select value={examType} onChange={(e) => setExamType(e.target.value)} className={inputClass}>
              <option value="">Seçin...</option>
              {examTypes.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </div>
          <div>
            <label className={labelClass}>Sınıf</label>
            <select value={grade} onChange={(e) => setGrade(e.target.value)} className={inputClass}>
              <option value="">Seçin...</option>
              {gradeOptions.map((g) => (
                <option key={g} value={g}>{g}</option>
              ))}
            </select>
          </div>
          <div>
            <label className={labelClass}>Ders</label>
            <select value={subject} onChange={(e) => setSubject(e.target.value)} className={inputClass}>
              <option value="">Seçin...</option>
              {subjectOptions.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>
          <div>
            <label className={labelClass}>Süre (dakika)</label>
            <input
              type="number"
              min={1}
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              className={inputClass}
              placeholder="Örn: 40"
            />
          </div>
        </div>

        <div className="mt-4">
          <label className={labelClass}>Soru Sayısı</label>
          <input
            type="number"
            min={0}
            value={questionCount}
            onChange={(e) => setQuestionCount(e.target.value)}
            className={`${inputClass} max-w-[180px]`}
            placeholder="Örn: 20"
          />
        </div>

        {message && (
          <p
            className={`mt-4 text-sm rounded-md p-3 ${
              message.type === "success"
                ? "bg-primary-100 text-primary-800"
                : "bg-warm/15 text-foreground-800"
            }`}
          >
            {message.text}
          </p>
        )}

        <div className="mt-6 pt-5 border-t border-background-200">
          <button
            type="submit"
            disabled={saving}
            className="whitespace-nowrap px-5 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
          >
            {saving ? "Oluşturuluyor..." : "Testi Kaydet"}
          </button>
        </div>
      </form>

      <PanelLinks
        links={[
          { label: "Soru Ekle", href: "/ogretmen/soru-ekle", icon: "ri-add-circle-line" },
          { label: "Deneme Oluştur", href: "/ogretmen/deneme-olustur", icon: "ri-file-text-line" },
        ]}
      />
    </div>
  );
}